import QorusClient from "@/api/clients/QorusClient";
import { Category } from "@/models/category";

/**
 *  Qorus API about categories
 */
export default class CategoryApi {
  static of(): CategoryApi {
    return new CategoryApi();
  }

  /**
   * Get tree of categories
   * @return CategoryDTO Tree of categories
   */
  getTree(): Promise<Category> {
    return QorusClient.client.get("categories", {}).then(
      (data) => {
        return data;
      },
      data => {
        throw data;
      },
    );
  }
}